export default __webpack_public_path__ + "static/media/offline-legend.36b665fa.svg";